import * as React from "react";
const IconSpeechlessCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
    <path d="M45.2 44.2H18.8c-.6 0-1 .4-1 1s.4 1 1 1h26.4c.6 0 1-.4 1-1s-.5-1-1-1M24.1 22.7c0-2.2-1.8-4-4-4s-4 1.8-4 4 1.8 4 4 4 4-1.8 4-4M43.9 18.8c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4c0-2.3-1.8-4-4-4" />
  </svg>
);
export default IconSpeechlessCopy;
